import React, { useContext } from "react";
import AuthenticationContext from "./AuthenticationContext";

const withAuth = WrappedComponent => props => {
  const contextVal = useContext(AuthenticationContext);
  return <WrappedComponent {...props} {...contextVal} />;
};

export default withAuth;
